module.exports = __webpack_public_path__ + "img/login_banner.4ccf7143.png";